import { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

type Props = {
  children?: ReactNode;
  className?: string;
  bgColor?: string;
  borderRadius?: "lg" | "xl";
};

const Container = ({
  children,
  className = "",
  bgColor = "bg-card",
  borderRadius = "lg",
}: Props) => (
  <div
    className={twMerge(
      "w-full",
      borderRadius === "lg" && "rounded-lg",
      borderRadius === "xl" && "rounded-xl",
      bgColor,
      className,
    )}
  >
    {children}
  </div>
);

export default Container;
